import { useState } from "react";
import "./css/adminpushtemplateeditmodal.css";
import { apiPut } from "../../../utils/apiClient";

const AdminPushTemplateEditModal = ({ onClose, activeType, item, onSuccess }) => {
  const [recipient, setRecipient] = useState(item?.receiverType ?? "가맹점");
  const [sendHour, setSendHour] = useState(item?.sendDateTime?.slice(0, 2) ?? "");
  const [sendMinute, setSendMinute] = useState(item?.sendDateTime?.slice(3, 5) ?? "");
  const [title, setTitle] = useState(item?.title ?? "");
  const [content, setContent] = useState(item?.content ?? "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const MAX_LEN = 50;

  const handleSubmit = async () => {
    setErrorMsg("");
    if (!title.trim()) return setErrorMsg("제목을 입력해 주세요.");
    if (!content.trim()) return setErrorMsg("내용을 입력해 주세요.");
    if (activeType === "auto" && (!sendHour || !sendMinute))
      return setErrorMsg("발송 시간을 선택해 주세요.");

    const payload = {
      title: title.trim(),
      content: content.trim(),
      receiverType: recipient,
      isAuto: activeType === "auto",
      sendDateTime: activeType === "auto" ? `${sendHour}:${sendMinute}:00` : null,
    };

    setIsSubmitting(true);
    const response = await apiPut(`/admin/pushTemplate/${item.pushTemplateIdx}`, payload);
    setIsSubmitting(false);

    if (response.ok) {
      onSuccess?.();
      onClose();
    } else {
      setErrorMsg("템플릿 수정에 실패했습니다.");
    }
  };

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0"),
  );
  const minutes = ["00", "10", "20", "30", "40", "50"];

  return (
    <div className="adminpushtemplateeditmodal-backdrop" onClick={onClose}>
      <div className="adminpushtemplateeditmodal-wrap" onClick={(e) => e.stopPropagation()}>
        <div className="adminpushtemplateeditmodal-header">
          <div className="adminpushtemplateeditmodal-header-title">템플릿 수정</div>
          <div className="adminpushtemplateeditmodal-header-subtitle">
            {activeType === "direct"
              ? "즉시 발송 템플릿을 수정합니다"
              : "시스템 발송(자동) 템플릿을 수정합니다"}
          </div>
        </div>
        <div className="adminpushtemplateeditmodal-body">
          <div className="adminpushtemplateeditmodal-section">
            <div className="adminpushtemplateeditmodal-field-row">
              <div className="adminpushtemplateeditmodal-field">
                <span className="adminpushtemplateeditmodal-label">수신 대상</span>
                <select
                  className="adminpushtemplateeditmodal-select adminpushtemplateeditmodal-select-full"
                  value={recipient}
                  onChange={(e) => setRecipient(e.target.value)}
                >
                  <option value="가맹점">가맹점</option>
                  <option value="사용자">사용자</option>
                </select>
              </div>
              <div
                className="adminpushtemplateeditmodal-field"
                style={{ visibility: activeType === "auto" ? "visible" : "hidden" }}
              >
                <span className="adminpushtemplateeditmodal-label">발송 시각</span>
                <div className="adminpushtemplateeditmodal-time-row">
                  <select
                    className="adminpushtemplateeditmodal-select"
                    value={sendHour}
                    onChange={(e) => setSendHour(e.target.value)}
                  >
                    <option value="">--</option>
                    {hours.map((h) => (
                      <option key={h} value={h}>
                        {h}
                      </option>
                    ))}
                  </select>
                  <span className="adminpushtemplateeditmodal-time-unit">시</span>
                  <select
                    className="adminpushtemplateeditmodal-select"
                    value={sendMinute}
                    onChange={(e) => setSendMinute(e.target.value)}
                  >
                    <option value="">--</option>
                    {minutes.map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                  <span className="adminpushtemplateeditmodal-time-unit">분</span>
                </div>
              </div>
            </div>
          </div>

          {/* 공통 영역 */}
          <div className="adminpushtemplateeditmodal-section">
            <div className="adminpushtemplateeditmodal-field">
              <div className="adminpushtemplateeditmodal-label-row">
                <span className="adminpushtemplateeditmodal-label">제목</span>
                <span className="adminpushtemplateeditmodal-char-count">
                  {title.length} / {MAX_LEN}
                </span>
              </div>
              <input
                className="adminpushtemplateeditmodal-input"
                type="text"
                placeholder="제목을 입력하세요"
                value={title}
                onChange={(e) => {
                  if (e.target.value.length <= MAX_LEN)
                    setTitle(e.target.value);
                }}
                maxLength={MAX_LEN}
              />
            </div>
            <div className="adminpushtemplateeditmodal-field">
              <div className="adminpushtemplateeditmodal-label-row">
                <span className="adminpushtemplateeditmodal-label">내용</span>
                <span className="adminpushtemplateeditmodal-char-count">
                  {content.length} / {MAX_LEN}
                </span>
              </div>
              <textarea
                className="adminpushtemplateeditmodal-textarea"
                placeholder="내용을 입력하세요"
                rows={4}
                value={content}
                onChange={(e) => {
                  if (e.target.value.length <= MAX_LEN)
                    setContent(e.target.value);
                }}
                maxLength={MAX_LEN}
              />
            </div>
          </div>
        </div>

        {errorMsg && (
          <div className="adminpushtemplateeditmodal-error">{errorMsg}</div>
        )}
        <div className="adminpushtemplateeditmodal-footer">
          <button
            className="adminpushtemplateeditmodal-btn-submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "저장 중..." : "저장"}
          </button>
          <button className="adminpushtemplateeditmodal-btn-cancel" onClick={onClose}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPushTemplateEditModal;
